<template>
  <div :style="{ 'margin-top': margin + 'px!important' }">
    <v-text-field
      :clearable="clearable"
      @click:clear="cleared"
      @blur="inputBlurred"
      @focus="inputBlurred"
      @keyup="typeWasDone"
      :rules="dateValidation"
      v-bind:value="date"
      :placeholder="placeholder || ''"
      outlined
      dense
      :v-mask="'####-##-##'"
      :label="label"
      :prepend-inner-icon="prependIcon"
      autocomplete="off"
      required
      class="pa-0 ma-0 calendar_picker_input"
      name="calendar_picker_input"
      :disabled="disabled"
      :id="idVal"
    />
    <p
      v-if="showConverted === true"
      style="margin-top:-1px;color:#555;font-weight:bold;font-size:12px"
    >
      {{ getDateFormat() }}
    </p>
  </div>
</template>

<script>
import { validateDate } from "../library/helpers";
const NepaliDate = require("nepali-date-js");
let yesterday = new Date();
let today = new Date();
yesterday.setDate(today.getDate() - 1);

const d4 = new NepaliDate(yesterday);

export default {
  props: {
    value: { type: String },
    showConverted: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    label: { type: String, required: true },
    disablePreviousDate: { type: Boolean, default: false },
    idVal: { type: String },
    placeholder: { type: String },
    prependIcon: { type: String },
    disabled: { type: Boolean, default: false },
    margin: { type: Number, default: -20 },
  },
  data: () => ({
    date: "",
    dateValidation: [(v) => validateDate(v) || "Invalid Date Format"],
  }),
  watch: {},
  mounted() {
    setTimeout(() => {
      this.date = this.value;
    }, 2000);
    let $this = this;
    try {
      const today = d4.format("MM/DD/YYYY");
      const dateObject = {
        dateFormat: "%y-%m-%d",
        closeOnDateSelect: false,
        npdMonth: true,
        npdYear: true,
        onChange: function() {
          $this.date = $("#" + $this.idVal).val();
          $this.$emit("input", $this.date);
          $this.$emit("onChange", $this.date);
        },
      };
      if (this.disablePreviousDate) {
        dateObject.disableBefore = today;
      }
      jQuery("#" + this.idVal).nepaliDatePicker(dateObject);
    } catch (e) {}
  },
  methods: {
    typeWasDone(e) {
      e.target.value = "";
      this.date = "";
      this.$emit("input", "");
    },
    inputBlurred(e) {
      if (!validateDate(e.target.value)) {
        e.target.value = "";
        this.date = "";
        this.$emit("input", "");
      }
    },
    getDateFormat() {
      try {
        if (!this.date) return "";
        let dateInstance = new NepaliDate(this.date.dateForm());
        return dateInstance.format("mmmm d, yyyy dddd");
      } catch (e) {
        return "";
      }
    },
    cleared() {
      this.date = "";
      this.$emit("input", "");
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
// .calendar_picker_input {
//   margin-bottom: 0 !important;
//   padding-bottom: 0 !important;
// }
</style>
